export default __webpack_public_path__ + "static/winter-holidays_3-b9af65460631530627e383f6b30ab25e.png";